module.exports = __webpack_public_path__ + "img/18m.a9c6c66a.jpg";